import * as Sentry from '@sentry/react';
import { gtm, fatalErrorEvent } from '~/common/utils/tracking.js';
import LogPAPIError from './PAPIErrorLogging.js';

const logError = (errObj = {}) => {
    const err = errObj;
    let extra = {};

    // assign value to "extra" object that is sent to sentry
    try {
        extra = { err };
    } catch (e) {
        extra = { err: 'Unable to assign [extra] error object' };
    }

    if (ENV === 'production') {
    // should be an object
        if (typeof err !== 'object') {
            try {
                // try to assign the error to a value in an object
                return Sentry.captureMessage('Unexpected Error Format', { extra });
            } catch (e) {
                return Sentry.captureMessage('Unhandled Error Format', { extra: e });
            }
        }

        // send to PAPI error handler if err object contains a response object
        if (err.response) {
            return LogPAPIError(err);
        }

        // most standard non-API errors will fall here
        try {
            if (err.customMessage) {
                return Sentry.captureMessage(err.customMessage, { extra });
            }
            return Sentry.captureMessage('Undefined Error Message', { extra });
        } catch (e) {
            return Sentry.captureMessage('This error should not happen', { extra: e });
        }
    }

    // log to console in dev
    if (ENV !== 'test') {
        return console.log(err.response || err);
    }

    // For all non-prod envs, call gtm fatal error event for 400 or 500 codes
    if (err.response) {
        const errorCode = err.response?.data?.statusCode;
        if (errorCode && `${errorCode}`.length === 3 && (`${errorCode}`.charAt(0) === '4' || `${errorCode}`.charAt(0) === '5')) {
            gtm(fatalErrorEvent(extra.data.message));
        }
    }

    // catch anything else that falls through
    try {
        return Sentry.captureMessage(err);
    } catch (e) {
        return Sentry.captureMessage('This error should REALLY not happen', { extra: e });
    }
};

export default logError;
